import { useEffect } from "react";
import "./app.css";
import "./global.css";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
// import Login from "../pages/Login/login";
// import ButtonPage from "../pages/ButtonPage/buttonPage";
import { Login, ButtonPage, Result, MusicList, ChatBot, Camera } from "common/index";

// import Camera from "../pages/Camera";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isLogin = sessionStorage.getItem("isLogin");
    isLogin !== "true" && location.pathname !== "/login" && navigate("/login");
  }, [location]);

  return (
    <div id="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ButtonPage />} />
        <Route path="/chatbot" element={<ChatBot />} />
        <Route path="/emotion" element={<Camera />} />
        <Route path="/result" element={<Result />} />
        <Route path="/musiclist" element={<MusicList />} />
      </Routes>
      <img
        onClick={() => {
          navigate("/");
        }}
        className="z-[100] fixed w-56 right-8 top-8 ces_logo"
        src="/imgs/etc/logo1.png"
        alt=""
      />
    </div>
  );
}

export default App;
